(function(){
"use strict";
var form=document.querySelector(".dema-form");if(!form)return;
var RM=matchMedia("(prefers-reduced-motion: reduce)").matches;
var host=document.getElementById("demaOpts");
if(!host){host=document.createElement("div");host.id="demaOpts";var a=document.getElementById("demaAvis");if(a)a.parentNode.insertBefore(host,a);else form.appendChild(host)}
function touch(){if(window.__demaSyncPrice)window.__demaSyncPrice()}
function esc(s){return String(s).replace(/"/g,'\\"')}
function live(name,value){return document.querySelector('.dema-form .avp-option input[name="'+esc(name)+'"][value="'+esc(value)+'"]')}
function select(name,value){
 var inp=live(name,value);
 if(!inp)return;
 var lab=inp.closest("label");
 try{ if(lab)lab.click(); }catch(e){}
 if(!inp.checked){ try{inp.click()}catch(e){} }
 if(!inp.checked){
  inp.checked=true;
  ["input","change","click"].forEach(function(t){try{inp.dispatchEvent(new Event(t,{bubbles:true}))}catch(e){}});
 }
 touch();
}
function isPr(){return document.body.classList.contains("pr")}

var ICO={
 batt:'<rect x="2.5" y="8" width="16.5" height="8.6" rx="2.4"/><path d="M21.6 11v3M5.6 12.3h6"/>',
 shield:'<path d="M12 2.5l7.5 3.5v6c0 5-3.2 8.4-7.5 10-4.3-1.6-7.5-5-7.5-10v-6z"/><path d="M9 12l2.2 2.2L15.5 10"/>',
 plug:'<rect x="5" y="2.5" width="14" height="12" rx="3.2" stroke-width="2.1"/><path d="M9.3 6.2v3.4M14.7 6.2v3.4" stroke-width="2.4"/><path d="M12 14.5v3.2" stroke-width="2.1"/><path d="M12 17.7c0 2 1.6 3.6 3.6 3.6" stroke-width="2.1"/>',
 star:'<path d="M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.6 6.6 19.5l1.2-6L3.3 9.3l6.1-.7z"/>'
};
function svg(k,s){return '<svg width="'+(s||16)+'" height="'+(s||16)+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">'+ICO[k]+'</svg>'}
var bolt='<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L4.5 13.5H11l-1 8.5 8.5-11.5H12z"/></svg>';
var check='<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M4 12.5l4.5 4.5L20 6"/></svg>';

function read(){
 var out=[];
 [].forEach.call(document.querySelectorAll(".dema-form .avp-option"),function(op){
  var t=op.querySelector(".apo-title");
  var name=t?t.textContent.trim():"";
  var vals=[];
  [].forEach.call(op.querySelectorAll('input[type=radio],input[type=checkbox]'),function(inp){
   var lab=inp.closest("label");
   var txt=lab?lab.textContent.replace(/\s+/g," ").trim():inp.value;
   var m=txt.match(/\+\s*\u20ac\s*[\d.,]+/);
   vals.push({field:inp.getAttribute("name")||name,value:inp.value,label:txt.replace(/\(?\+\s*\u20ac[\d.,]+\)?/,"").trim(),price:m?("+ "+m[0].replace(/\+\s*/,"")):"",checked:inp.checked});
  });
  if(name&&vals.length)out.push({name:name,vals:vals});
 });
 return out;
}
function burst(o,ev){
 if(RM)return;
 var r=o.getBoundingClientRect();
 var cx=ev&&ev.clientX?ev.clientX-r.left:r.width/2, cy=ev&&ev.clientY?ev.clientY-r.top:r.height/2;
 var d=Math.max(r.width,r.height)*2.2;
 var w=document.createElement("span");w.className="dbwave";
 w.style.cssText="left:"+cx+"px;top:"+cy+"px;width:"+d+"px;height:"+d+"px;animation:dbwaveGo .75s ease-out forwards";
 o.appendChild(w);setTimeout(function(){w.remove()},760);
 for(var i=0;i<10;i++){
  var sp=document.createElement("span");sp.className="dbspark";
  var a=Math.random()*Math.PI*2,dist=26+Math.random()*46;
  sp.style.cssText="left:"+cx+"px;top:"+cy+"px;--dx:"+(Math.cos(a)*dist).toFixed(0)+"px;--dy:"+(Math.sin(a)*dist).toFixed(0)+"px;animation:dbsparkGo "+(420+Math.random()*380)+"ms ease-out forwards";
  o.appendChild(sp);(function(e){setTimeout(function(){e.remove()},900)})(sp);
 }
}

var signature="";
function build(force){
 var groups=read();
 if(!groups.length)return false;
 var sig=JSON.stringify(groups.map(function(g){return [g.name,g.vals.map(function(v){return v.value})]}))+"|"+isPr();
 if(!force&&sig===signature)return true;
 signature=sig;
 host.innerHTML="";
 groups.forEach(function(g){
  var isBatt=/batteri/i.test(g.name);
  var isGar=/garanz/i.test(g.name);
  var wrap=document.createElement("div");

  if(isBatt){
   wrap.className="dbatt";
   wrap.innerHTML='<p class="dblab"><span class="bi">'+svg("batt",15)+'</span>'+g.name+'</p><div class="dbseg"></div>'+
    '<button type="button" class="dbinfo" id="openBat"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 7.6v.5"/></svg>Che batterie usiamo</button>';
   var seg=wrap.querySelector(".dbseg");
   g.vals.forEach(function(v){
    var neon=/nuov/i.test(v.label);
    var b=document.createElement("button");
    b.type="button";b.className="dbopt"+(neon?" neon":"");
    b.dataset.field=v.field;b.dataset.value=v.value;
    b.setAttribute("aria-pressed",v.checked?"true":"false");
    b.innerHTML='<span class="dbicon">'+(neon?bolt:check)+'</span><span class="bt">'+v.label+'</span>'+
      '<span class="dbcell"><span class="dbshell"><span class="dblevel"></span>'+(neon?'<span class="dbbolt">'+bolt+'</span>':'')+'</span><span class="dbcap"></span><span class="dbpct">'+(neon?"100%":"82%+")+'</span><span class="bp">'+(v.price||"Inclusa")+'</span></span>';
    b.addEventListener("click",function(ev){
     select(v.field,v.value);
     [].forEach.call(seg.children,function(x){x.setAttribute("aria-pressed","false")});
     b.setAttribute("aria-pressed","true");
     if(neon)burst(b,ev);
    });
    seg.appendChild(b);
   });
   host.appendChild(wrap);
   return;
  }

  var ic=isGar?"shield":(/aliment|spina|carica/i.test(g.name)?"plug":"star");
  wrap.className="dupgrp";
  wrap.innerHTML='<p class="dblab"><span class="bi">'+svg(ic,15)+'</span>'+g.name+'</p><div class="dups"></div>';
  var list=wrap.querySelector(".dups");

  var vals=g.vals;
  var premGar=isGar&&isPr();
  if(premGar){
   /* nascondo 1 e 2 anni: sul Premium i 24 mesi sono gia' dentro */
   vals=g.vals.filter(function(v){return !/^(1\s*anno|2\s*anni)/i.test(v.label.trim())});
   var base=g.vals.filter(function(v){return !v.price})[0];
   if(base){
    var inc=document.createElement("button");
    inc.type="button";inc.className="dup dupinc";
    inc.dataset.field=base.field;inc.dataset.value=base.value;
    inc.innerHTML='<span class="ic">'+svg("shield",15)+'</span><p>24 mesi<span>Inclusi nel grado Premium</span></p><b>Inclusa</b>';
    inc.addEventListener("click",function(){
     select(base.field,base.value);
     [].forEach.call(list.children,function(x){x.setAttribute("aria-pressed","false")});
     inc.setAttribute("aria-pressed","true");
    });
    list.appendChild(inc);
    var cur=live(base.field,base.value);
    inc.setAttribute("aria-pressed",cur&&cur.checked?"true":"false");
    if(cur&&!cur.checked){
     var anyPaid=g.vals.some(function(v){var i=live(v.field,v.value);return v.price&&i&&i.checked});
     if(!anyPaid)select(base.field,base.value);
    }
   }
  }

  vals.forEach(function(v){
   var b=document.createElement("button");
   b.type="button";b.className="dup";
   b.dataset.field=v.field;b.dataset.value=v.value;
   b.setAttribute("aria-pressed",v.checked?"true":"false");
   var sub=v.price?(premGar?"Estendi oltre i 24 mesi inclusi":"Aggiunta opzionale"):"Incluso";
   b.innerHTML='<span class="ic">'+svg(ic,15)+'</span><p>'+v.label+'<span>'+sub+'</span></p><b>'+(v.price||"Incluso")+'</b>';
   b.addEventListener("click",function(){
    select(v.field,v.value);
    [].forEach.call(list.children,function(x){x.setAttribute("aria-pressed","false")});
    b.setAttribute("aria-pressed","true");
   });
   list.appendChild(b);
  });
  host.appendChild(wrap);
 });
 var ob=document.getElementById("openBat");
 if(ob)ob.addEventListener("click",function(){var m=document.getElementById("mBat");if(m){m.classList.add("on");document.body.style.overflow="hidden"}});
 touch();
 return true;
}

if(window.MutationObserver){
 var t;
 new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){build()},120)})
  .observe(document.body,{attributes:true,attributeFilter:["class"]});
}
var tries=0;
(function wait(){
 if(build()){
  var box=document.querySelector(".dema-form .avpoptions-container__v2");
  if(box&&window.MutationObserver){
   var t2;
   new MutationObserver(function(){clearTimeout(t2);t2=setTimeout(function(){build()},150)}).observe(box,{subtree:true,childList:true});
  }
  return;
 }
 if(++tries>40)return;
 setTimeout(wait,250);
})();
})();
